module.exports = __webpack_public_path__ + "static/img/mobile-bg-1x.a0f9a28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile-bg-1x.png
// module id = K7DO
// module chunks = 21 36